import { GzBuyProductCardWebComponent } from './component/GzBuyProductCardWebComponent';

export { GzBuyProductCardWebComponent };
